(function () {
  const catalog = window.CATALOG;
  if (!catalog) return;

  const { series, products } = catalog;
  const i18n = window.PH_PRODUCTS_I18N || {};
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[character]));
  }

  function productUrl(product) {
    return product.url || `/products/${encodeURIComponent(product.slug)}`;
  }


  // Hot-sale ranking now comes from the product metafield custom.hot_rank.
  // Set it in Shopify Admin; leave empty to hide the badge.
  function getHotSaleRank(item) {
    const rank = Number(item.hotRank);
    return Number.isFinite(rank) && rank > 0 ? rank : null;
  }

  function sortHotSaleFirst(items) {
    return items
      .map((item, index) => ({ item, index, rank: getHotSaleRank(item) || 999 }))
      .sort((a, b) => (a.rank - b.rank) || (a.index - b.index))
      .map((entry) => entry.item);
  }

  function hotSaleBadge(item) {
    const rank = getHotSaleRank(item);
    if (!rank) return '';
    return `<span class="hot-sale-badge" aria-label="${escapeHtml(i18n.hotProduct || 'Hot sale product')}"><strong>${escapeHtml(i18n.hotSale || 'HOT\nSALE')}</strong></span>`;
  }

  const SEARCH_SYNONYMS = {
    'flexible stone': ['soft stone', 'bendable stone', 'stone veneer', 'lightweight stone', 'thin stone', 'stone cladding'],
    'wall cladding': ['wall panel', 'wall covering', 'wall finish', 'decorative wall panel', 'wall material'],
    'facade': ['exterior', 'exterior wall', 'building exterior', 'outdoor wall'],
    'interior': ['interior wall', 'indoor wall', 'hotel lobby', 'restaurant wall', 'retail backdrop'],
    'fireproof': ['fire resistant', 'fire rating', 'a2', 'astm e84', 'flame resistant'],
    'certificate': ['certification', 'test report', 'ce', 'ul', 'singapore green label'],
    'renovation': ['refurbishment', 'remodel', 'old wall', 'retrofit'],
    'wood': ['timber', 'natural wood', 'wood grain'],
    'brick': ['masonry', 'k brick', 'clay brick'],
    'travertine': ['beige stone', 'limestone look', 'roman stone']
  };

  function normalizeSearchText(value) {
    return String(value || '').toLowerCase().replace(/[-_/]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function expandQueryTerms(query) {
    const normalized = normalizeSearchText(query);
    const terms = new Set(normalized.split(' ').filter(Boolean));
    Object.entries(SEARCH_SYNONYMS).forEach(([key, variants]) => {
      if (normalized.includes(key) || variants.some((variant) => normalized.includes(variant))) {
        key.split(' ').forEach((part) => terms.add(part));
        variants.join(' ').split(' ').forEach((part) => terms.add(part));
      }
    });
    return Array.from(terms).filter((term) => term.length > 1);
  }

  function searchableProductText(item) {
    const specs = Array.isArray(item.specs) ? item.specs.flat().join(' ') : '';
    const applications = Array.isArray(item.applications) ? item.applications.join(' ') : '';
    return normalizeSearchText([
      item.name,
      item.slug,
      item.series,
      item.seriesId,
      item.short,
      item.story,
      item.applicationText,
      applications,
      specs,
      'flexible stone wall cladding lightweight stone veneer decorative wall panel interior exterior facade renovation hotel villa restaurant certificate fireproof'
    ].join(' '));
  }

  function scoreProduct(item, query) {
    const value = normalizeSearchText(query);
    const terms = expandQueryTerms(value);
    if (!terms.length) return 0;
    const haystack = searchableProductText(item);
    let score = 0;
    if (normalizeSearchText(item.name).includes(value)) score += 25;
    if (normalizeSearchText(item.series).includes(value)) score += 12;
    if (haystack.includes(value)) score += 10;
    terms.forEach((term) => {
      if (normalizeSearchText(item.name).includes(term)) score += 8;
      if (normalizeSearchText(item.series).includes(term)) score += 5;
      if (haystack.includes(term)) score += 2;
    });
    return score;
  }


  function updateHeader() {
    const header = $('[data-header]');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 18);
  }

  function setupNavigation() {
    const menu = $('[data-mobile-menu]');
    const toggle = $('[data-menu-toggle]');
    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const isOpen = menu.classList.toggle('is-open');
        menu.setAttribute('aria-hidden', String(!isOpen));
        document.body.classList.toggle('no-scroll', isOpen);
      });
      $$('a', menu).forEach((link) => link.addEventListener('click', () => {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('no-scroll');
      }));
    }
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  function renderSearchResults(query) {
    const resultsRoot = $('[data-search-results]');
    if (!resultsRoot) return;
    const value = String(query || '').trim();
    if (!value) {
      resultsRoot.innerHTML = '<p class="search-empty">Search by product, series, texture, application, certificate or performance keyword.</p>';
      return;
    }
    const scoredProducts = products
      .map((item) => ({ item, score: scoreProduct(item, value) }))
      .filter((entry) => entry.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 10);

    const pageMatches = [
      { title: 'Certificates & Technical Reports', subtitle: 'CE, UL, Singapore Green Label, fire performance and weathering documents', url: '/pages/contact-us', keywords: 'certificate certification report CE UL Singapore Green Label fireproof A2 ASTM weathering freeze thaw test' },
      { title: 'Installation & Samples', subtitle: 'Request catalogue, specifications, samples and installation information', url: '/pages/contact-us', keywords: 'installation sample catalog catalogue specification adhesive inquiry contact' },
      { title: 'About 21ParkHouse', subtitle: 'Factory strength, patented technology and sustainable manufacturing', url: '/pages/about-us', keywords: 'about factory manufacturer patented technology sustainable ESG automated production' }
    ].map((item) => {
      const haystack = normalizeSearchText(`${item.title} ${item.subtitle} ${item.keywords}`);
      const score = expandQueryTerms(value).reduce((total, term) => total + (haystack.includes(term) ? 2 : 0), haystack.includes(normalizeSearchText(value)) ? 8 : 0);
      return { item, score };
    }).filter((entry) => entry.score > 0).sort((a, b) => b.score - a.score).slice(0, 3);

    if (!scoredProducts.length && !pageMatches.length) {
      resultsRoot.innerHTML = '<p class="search-empty">No direct result found. Try terms like flexible stone, travertine, wall cladding, facade, fireproof or certificate.</p>';
      return;
    }

    const productHtml = scoredProducts.length ? `
      <div class="search-group"><span class="search-group-title">Products</span>
        ${scoredProducts.map(({ item }) => `
          <a class="search-result" href="${productUrl(item)}">
            <img src="${item.image}" alt="${escapeHtml(item.name)} flexible stone texture">
            <span><strong>${escapeHtml(item.name)}</strong><small>${escapeHtml(item.series)} · Flexible Stone wall cladding</small></span>
            <i aria-hidden="true">→</i>
          </a>
        `).join('')}
      </div>` : '';

    const pageHtml = pageMatches.length ? `
      <div class="search-group"><span class="search-group-title">Resources</span>
        ${pageMatches.map(({ item }) => `
          <a class="search-result" href="${item.url}">
            <span></span>
            <span><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.subtitle)}</small></span>
            <i aria-hidden="true">→</i>
          </a>
        `).join('')}
      </div>` : '';

    resultsRoot.innerHTML = productHtml + pageHtml;
  }

  function setupSearch() {
    const layer = $('[data-search-layer]');
    const open = $('[data-search-open]');
    const close = $('[data-search-close]');
    const input = $('[data-search-input]');
    if (!layer || !open || !close || !input) return;

    const openSearch = () => {
      layer.classList.add('is-open');
      layer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      input.value = '';
      renderSearchResults('');
      window.setTimeout(() => input.focus(), 20);
    };
    const closeSearch = () => {
      layer.classList.remove('is-open');
      layer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    };
    open.addEventListener('click', openSearch);
    close.addEventListener('click', closeSearch);
    layer.addEventListener('click', (event) => {
      if (event.target === layer) closeSearch();
    });
    input.addEventListener('input', () => renderSearchResults(input.value));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && layer.classList.contains('is-open')) closeSearch();
    });
  }

  function initOverview() {
    const seriesGrid = $('[data-series-grid]');
    const productGrid = $('[data-product-grid]');
    if (!seriesGrid || !productGrid) return;

    const title = $('[data-active-series-name]');
    const viewButtons = $$('[data-view]');
    const params = new URLSearchParams(window.location.search);
    const querySeries = params.get('series');
    const fallbackId = series.length ? series[0].id : '';
    let activeId = series.some((item) => item.id === querySeries) ? querySeries : fallbackId;
    let activeView = 'grid';

    function renderSeriesCards() {
      seriesGrid.innerHTML = series.map((item) => {
        const active = item.id === activeId;
        return `
          <button class="series-card${active ? ' is-active' : ''}" type="button" data-series-id="${item.id}" aria-pressed="${active}">
            <img class="series-card-image" src="${item.cardImage || item.image}" alt="${escapeHtml(item.name)}">
            <span class="series-card-copy"><h3>${escapeHtml(item.name)}</h3></span>
          </button>
        `;
      }).join('');

      $$('[data-series-id]', seriesGrid).forEach((button) => {
        button.addEventListener('click', () => setActiveSeries(button.dataset.seriesId, true));
      });
    }

    function renderProductCards(items) {
      productGrid.innerHTML = items.map((item, index) => {
        const isHotSale = Boolean(getHotSaleRank(item));
        return `
        <a class="product-card${item.caseImage ? ' has-case' : ''}${isHotSale ? ' is-hot-sale' : ''}" href="${productUrl(item)}" style="--swatch:${item.accent}">
          <span class="product-media">
            <img class="product-media__texture" src="${item.image}" alt="${escapeHtml(item.imageAlt || item.name + ' Flexible Stone texture')}" loading="lazy">
            ${item.caseImage ? `<img class="product-media__case" src="${item.caseImage}" alt="${escapeHtml(item.name)}" loading="lazy">` : ''}
                ${hotSaleBadge(item)}
          </span>
          <span class="product-card-body">
            <span><h3>${escapeHtml(item.name)}</h3><span class="product-summary">${escapeHtml(item.short)}</span></span>
            <span class="product-arrow" aria-hidden="true">→</span>
          </span>
        </a>
      `;
      }).join('');
      productGrid.classList.toggle('is-list', activeView === 'list');
    }

    function updateUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set('series', activeId);
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }

    function setActiveSeries(id, animated) {
      const activeSeries = series.find((item) => item.id === id);
      if (!activeSeries) return;
      activeId = id;
      const selectedProducts = sortHotSaleFirst(products.filter((item) => item.seriesId === id));

      const paint = () => {
        renderSeriesCards();
        title.textContent = activeSeries.name;
        renderProductCards(selectedProducts);
        updateUrl();
      };

      if (animated) {
        productGrid.classList.add('is-switching');
        window.setTimeout(() => {
          paint();
          requestAnimationFrame(() => productGrid.classList.remove('is-switching'));
        }, 180);
      } else {
        paint();
      }
    }

    viewButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeView = button.dataset.view;
        viewButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
        productGrid.classList.toggle('is-list', activeView === 'list');
      });
    });

    setActiveSeries(activeId, false);
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupNavigation();
    setupSearch();
    initOverview();
  });

  window.PRODUCT_UTILS = { productUrl, escapeHtml };
})();

// Automatically move the header underline to the current page.
(function setCurrentNavigationState() {
  function currentKey() {
    const current = `${window.location.pathname}${window.location.search}`.toLowerCase();
    const body = document.body;

    if (current.includes('about-us') || body.classList.contains('page-about')) return 'about';
    if (
      current.includes('/products') ||
      current.includes('flexible-stone') ||
      current.includes('21ph-products') ||
      body.classList.contains('page-products')
    ) return 'products';
    if (current.includes('contact-us') || body.classList.contains('page-contact')) return 'contact';
    if (
      current.includes('/blogs/news') ||
      current.includes('/articles/news') ||
      current.includes('/news') ||
      body.classList.contains('page-information')
    ) return 'information';
    return 'home';
  }

  function linkKey(link) {
    const href = (link.getAttribute('href') || '').toLowerCase();
    const text = (link.textContent || '').trim().toLowerCase();

    if (href.includes('about-us') || text === 'about us') return 'about';
    if (
      href.includes('/products') ||
      href.includes('flexible-stone') ||
      href.includes('21ph-products') ||
      text === 'products'
    ) return 'products';
    if (href.includes('contact-us') || text === 'contact us') return 'contact';
    if (
      href.includes('/blogs/news') ||
      href.includes('/articles/news') ||
      href.includes('/news') ||
      text === 'information'
    ) return 'information';
    if (text === 'home') return 'home';
    return '';
  }

  function applyActiveState() {
    const activeKey = currentKey();
    document.querySelectorAll('.site-nav a, .mobile-menu a').forEach((link) => {
      const isActive = linkKey(link) === activeKey;
      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyActiveState, { once: true });
  } else {
    applyActiveState();
  }
})();


